import React, { Component } from 'react'
import Chip from 'material-ui/Chip'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import config from '../../config/config'
import { getPlan, getToken, isAccountFree, isAccountStartter } from '../../lib'
import { fetchPlanDetails } from './actions'
import moment from 'moment'

const planStyle = {color: '#29B87A'}

class Details extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount = async () => {
    const token = getToken()
    this.props.fetchPlanDetails(token)
  }

  render() {
    return (
      <div style={{color: '#6B7C93'}}>
        {false && <div style={{fontSize: 12}} className='mb2'>
          <FormattedMessage id='plan.yourPlan'/>
        </div>}
        <div className='pl4 pr4 mb4 mt4'>
          {!this.props.planDetails.fvlite_auto_trial && <div className='flex justify-between mb4'>
            <span> <FormattedMessage id='PlanDetails.companyName'/></span>
            <span style={planStyle}>{this.props.planDetails.companyName}</span>
          </div>}
          {this.props.status == 'expire' && <div className='flex justify-between mb4'>
            <span><FormattedMessage id='PlanDetails.expiryDate'/></span>
            <span style={planStyle}>{this.props.planDetails.expirationDate}</span>
          </div>}
          <div className='flex justify-between mb4'>
            <span><FormattedMessage id='PlanDetails.status'/></span>
            <span style={planStyle}>{this.props.planDetails.fvlite_auto_trial ? 'Trial' : this.props.planDetails.contractStatus}</span>
          </div>
          {!this.props.planDetails.fvlite_auto_trial && <div>
          <div className='flex justify-between mb4'>
            <span><FormattedMessage id='PlanDetails.maxNumberofAccounts'/></span>
            <span style={planStyle}>{this.props.planDetails.currentAccount}</span>
          </div>
          <div className='flex justify-between mb4'>
            <span><FormattedMessage id='PlanDetails.fvliteDomain'/></span>
            <span style={planStyle}>{this.props.planDetails.domainUrlName + '.lfv.jp'}</span>
          </div>
          </div>}
          <div className='flex justify-between mb4'>
            <span><FormattedMessage id='PlanDetails.maxNumberofRooms'/></span>
            <span style={planStyle}>{this.props.planDetails.max_room_num_per_user}</span>
          </div>
        </div>
        <div
          className='pl4 pr4 mb1 mt5'
          style={{lineHeight: '24px'}}>
          {'プランに関するお問い合わせ:'}
          <br/>
          {'Email: freshvoice@anets.co.jp'}
          <br/>
          {'TEL: 03-5822-2038'}
          <br/>
          {'エイネット株式会社'}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    planDetails: state.planDetails,
    user: state.loginLayout.user
  }
}
const mapDispatchToProps = dispatch => ({
  fetchPlanDetails: (token) => dispatch(fetchPlanDetails(token))
})
export default connect(mapStateToProps, mapDispatchToProps)(
  Details
)



// WEBPACK FOOTER //
// src/components/PlanDetails/PlanDetails.js